import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { SupportService } from "../services/support-service";
import { Router } from "@angular/router";

import { AppService } from "../services/app.service";
import { MedicalProcedureSharedService } from "../services/medical-procedure-shared.service";
@Component({
  selector: "app-medical-questions",
  templateUrl: "./medical-questions.component.html",
  styleUrls: ["./medical-questions.component.scss"],
})
export class MedicalQuestionsComponent implements OnInit {
  examList: any;
  bodyPartsList: any;
  searchSubmit = false;
  cptCode = "";
  examId = "";
  bodyPartId = "";
  procedure = "";
  procedureList: any;
  TCProceduresList: any;
  saveMedicalQnsList: any;
  newQnList: any;
  activeMedicalQnsList: any;
  saveList: any;
  Message: any;
  selectedlang: any;
  questionAdded = false;
  showcptcode = false;
  modalRef: BsModalRef;
  config = {
    ignoreBackdropClick: true,
  };
  errorMessage: string;
  copyTCProcList: any;
  searchResult = "";
  notfound = false;
  searched = false;
  splicedId: any;
  medQnIndex: any;
  i: any;
  popuptype: any;
  generalvalidationMessage: any = "";
  originalqueBoolean = false;
  viewqueBoolean = false;
  savemedicalBoolean = false;
  showIndex = -1;
  cancelIndex = -1;
  getIndex = -1;
  question: any;
  submitted = false;
  save = false;
  validationMessage: any;
  alert: any;
  addqnshow = false;
  cancel = true;
  selected1 = false;
  selected2 = false;
  selected3 = false;
  selected = false;
  selectedType: any;
  type: "";
  @ViewChild("validateAddedQn") validateAddedQn: TemplateRef<any>;
  @ViewChild("viewOriginalQn") viewOriginalQn: TemplateRef<any>;
  @ViewChild("removeMedQn") removeMedQn: TemplateRef<any>;

  constructor(
    private appservice: AppService,
    private modalService: BsModalService,
    private supportService: SupportService,
    private router: Router,
    private medicalProcedureShared: MedicalProcedureSharedService
  ) {
    this.examList = [];
    this.newQnList = [];
    this.bodyPartsList = [];
    this.procedureList = [];
    this.TCProceduresList = [];
    this.saveMedicalQnsList = [];
    this.saveList = [];
  }

  ngOnInit() {
    this.getcountrycodebytc();
    this.getallexams();
    this.getallprocedurebytc();
    this.getLanguage();
    this.changed("", "both");
    this.medicalProcedureShared.emitTestCenterAndStateNames(this);
  }

  getcountrycodebytc() {
    this.appservice.getcountrycodebytc().subscribe((res) => {
      if (res && res["status"] && res["status"]["status"] === 200) {
        if (res["entity"]) {
          if (res["entity"]["countryCode"]) {
            if (res["entity"]["countryCode"] === "US") {
              this.showcptcode = true;
            }
          }
        }
      } else {
        this.getCurrentIPAddress();
      }
    });
  }

  getCurrentIPAddress() {
    this.medicalProcedureShared.getCurrentIPAddress(this);
  }

  getAddressBasedonCurrentIp(ip) {
    this.appservice.getAddressBasedonCurrentIp(ip).subscribe(
      (res) => {
        if (res && res["status"] === "success" && res["countryCode"]) {
          if (res["countryCode"] === "IN") {
            this.showcptcode = false;
          } else {
            this.showcptcode = true;
          }
        } else if (
          res &&
          res["status"] === "success" &&
          res["lat"] &&
          res["lon"]
        ) {
          this.getAddressBasedonLatandLng(+res["lat"], +res["lon"], "initial");
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  getAddressBasedonLatandLng(latitude, longitude, type) {
    if (latitude && longitude) {
      this.appservice.getAddressFromGoogle(latitude, longitude).subscribe(
        (res) => {
          if (
            res &&
            res["status"] &&
            (res["status"] === "ok" || res["status"] === "OK")
          ) {
            if (res["results"][0]) {
              const firsttime = false;
              if (res["results"][0]["address_components"]) {
                for (
                  let index = 0;
                  index < res["results"][0]["address_components"].length;
                  index++
                ) {
                  if (
                    res["results"][0]["address_components"][index][
                      "types"
                    ][0] === "country"
                  ) {
                    if (
                      res["results"][0]["address_components"][index][
                        "long_name"
                      ] === "India" ||
                      res["results"][0]["address_components"][index][
                        "long_name"
                      ] === "india"
                    ) {
                      this.showcptcode = false;
                    } else {
                      this.showcptcode = true;
                    }
                  }
                }
              }
            }
          }
        },
        (err) => {
          this.appservice.sessionOut(err);
        }
      );
    }
  }

  getLanguage() {
    this.appservice.getlang().subscribe((res) => {
      if (res && res["commonMsg"]) {
        this.selectedlang = res["commonMsg"];
      }
    });
  }
  getallexams() {
    this.appservice.getAllExamswithTcId().subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"]) {
            this.examList = res["entity"];
          }
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign(this.config, { class: "popup-center" })
    );
  }
  getallbodypartsbyexamid(examid) {
    const data = {
      examId: examid,
    };
    this.appservice.getallbodypartsbyexamid(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"]) {
            this.bodyPartsList = res["entity"];
          }
        }
        if (res && res["status"] && res["status"]["status"] === 204) {
          this.Message = "";
          this.errorMessage = this.selectedlang.noRecBody;
        }
        if (res && res["status"] && res["status"]["status"] === 230) {
          this.Message = "";
          this.errorMessage = this.selectedlang.dataRequired;
        }
        setTimeout(() => {
          this.Message = "";
          this.errorMessage = "";
        }, 5000);
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }
  getallproceduresbybodypart(examId, bodypartId) {
    this.procedure = "";
    const data = {
      bodypartId: bodypartId,
    };
    this.appservice.getallproceduresbybodypart(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"]) {
            this.procedureList = res["entity"].map((row) =>
              this.normalizeProcedureRow(row)
            );
          }
        }
        if (res && res["status"] && res["status"]["status"] === 204) {
          this.Message = "";
          this.errorMessage = this.selectedlang.noRecProc;
        }
        if (res && res["status"] && res["status"]["status"] === 230) {
          this.Message = "";
          this.errorMessage = this.selectedlang.dataRequired;
        }
        setTimeout(() => {
          this.Message = "";
          this.errorMessage = "";
        }, 5000);
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  getallprocedurebytc() {
    this.save = false;
    this.TCProceduresList = [];
    const data = {
      testCenterId: localStorage.getItem("testCenterId"),
    };
    this.appservice.getallprocedurebytc(data).subscribe(
      (res) => {
        if (res && res["entity"]) {
          this.TCProceduresList = res["entity"].map((row) =>
            this.normalizeProcedureRow(row)
          );
          this.copyTCProcList = this.TCProceduresList;
          for (let index = 0; index < this.TCProceduresList.length; index++) {
            this.TCProceduresList[index].medicalQnsList = [];
          }
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  getcptcodebyprocedure(i) {
    this.cptCode = this.procedureList[i].cptCode;
  }

  searchMedicalQn(cptCode) {
    this.searchSubmit = true;
    if (
      this.examId !== "" &&
      this.bodyPartId !== "" &&
      this.procedure !== "" &&
      this.cptCode !== ""
    ) {
      for (let index = 0; index < this.copyTCProcList.length; index++) {
        if (this.copyTCProcList[index].cptCode === cptCode) {
          this.searched = true;
          this.notfound = false;
          this.searchResult = this.copyTCProcList[index];
          this.TCProceduresList = [];
          this.TCProceduresList.push(this.searchResult);
          break;
        } else {
          this.notfound = true;
        }
        this.searchSubmit = false;
      }
      if (this.notfound) {
        this.notfound = true;
      }
    } else {
      this.alert = this.selectedlang.inf;
      this.validationMessage = this.selectedlang.fillAll;
      this.openModal(this.validateAddedQn);
    }
  }
  resetMedicalQn() {
    this.TCProceduresList = [];
    this.examId = "";
    this.bodyPartId = "";
    this.bodyPartsList = [];
    this.procedureList = [];
    this.procedure = "";
    this.cptCode = "";
    this.notfound = false;
    this.getallprocedurebytc();
    for (let index = 0; index < this.TCProceduresList.length; index++) {
      if (
        this.TCProceduresList[index].view === "true" ||
        this.TCProceduresList[index].view === "false"
      ) {
        this.TCProceduresList[index].view = "";
      }
    }
    this.showIndex = -1;
  }

  triggerPopup() {
    if (this.popuptype === "delete") {
      if (this.i) {
        this.removeprocedures(this.i);
      }
    }
    if (this.popuptype === "deletemed") {
      this.removeMedicalQn(this.splicedId, this.i, this.medQnIndex);
    }

    document.getElementById("closepopup").click();
  }

  removeprocedures(i) {
    const data = {
      id: this.i,
    };
    this.medicalProcedureShared.removeTcProcedure(this, data, i);
  }

  removeMedicalQn(id, i, m) {
    this.save = true;
    if (!id) {
      this.TCProceduresList[i].medicalQnsList.splice(m, 1);
      return;
    }
    if (
      this.TCProceduresList[i] &&
      this.TCProceduresList[i].medicalQnsList &&
      this.TCProceduresList[i].medicalQnsList.length > 0 &&
      this.TCProceduresList[i].medicalQnsList[m].id === id
    ) {
      this.TCProceduresList[i].medicalQnsList[m].active = false;
      this.TCProceduresList[i].medicalQnsList[m].deleted = true;
    }
    if (
      this.TCProceduresList[i].medicalQnsList &&
      this.TCProceduresList[i].medicalQnsList.length > 0
    ) {
      this.recalcMedIndex(i);
    }
    this.modalRef.hide();
  }

  private recalcMedIndex(i) {
    let prevInd = 0;
    for (let q = 0; q < this.TCProceduresList[i].medicalQnsList.length; q++) {
      this.TCProceduresList[i].medicalQnsList[q].medIndex = 0;
      if (this.TCProceduresList[i].medicalQnsList[q].active) {
        this.TCProceduresList[i].medicalQnsList[q].medIndex =
          this.TCProceduresList[i].medicalQnsList[prevInd].medIndex + 1;
        prevInd = q;
      }
    }
  }

  spliceMedQn(medQns, i, m) {
    this.splicedId = medQns;
    this.medQnIndex = m;
    this.i = i;
    this.alert = "Remove";
    this.popuptype = "deletemed";
    this.generalvalidationMessage = this.selectedlang.popupProcedure;

    this.openModal(this.removeMedQn);
  }

  popupConfirmationAfterSave(procedure) {
    this.i = procedure.id;
    this.alert = "Remove";
    this.popuptype = "delete";
    this.generalvalidationMessage = this.selectedlang.popupProcedure;
    this.openModal(this.removeMedQn);
  }
  getoriginalQuestions(i) {
    if (this.showIndex === i) {
      this.openModal(this.viewOriginalQn);
    }
  }
  loadOriginalQuestions(i) {
    this.save = true;
    if (
      this.TCProceduresList[i] &&
      this.TCProceduresList[i].medicalQnsList &&
      this.TCProceduresList[i].medicalQnsList.length > 0
    ) {
      for (let n = 0; n < this.TCProceduresList[i].medicalQnsList.length; n++) {
        this.TCProceduresList[i].medicalQnsList[
          n
        ].active = this.TCProceduresList[i].medicalQnsList[
          n
        ].medicalQuestion.defaults;
        this.TCProceduresList[i].medicalQnsList[n].deleted = !this
          .TCProceduresList[i].medicalQnsList[n].active;
      }

      this.recalcMedIndex(i);
    }
    this.modalRef.hide();
  }

  saveMedicalQns() {
    if (this.save) {
      this.savemedicalBoolean = true;
      for (let index = 0; index < this.TCProceduresList.length; index++) {
        if (this.TCProceduresList[index].medicalQnsList) {
          if (
            this.TCProceduresList[index].medicalQnsList.length > 0 &&
            this.TCProceduresList[index].medicalQnsList != null
          ) {
            for (
              let k = 0;
              k < this.TCProceduresList[index].medicalQnsList.length;
              k++
            ) {
              this.saveList.push(
                this.TCProceduresList[index].medicalQnsList[k]
              );
            }
          }
        }
      }

      const data = {
        tcMedicalQuestion: this.saveList,
      };
        this.appservice.addorupdatemedicalqn(data).subscribe(
          (res) => {
            if (res && res["status"] && res["status"]["status"] === 200) {
              this.saveList = [];
              this.getallprocedurebytc();
              this.Message = this.selectedlang.medAddedSuccessfully;
              setTimeout(() => {
                this.Message = "";
              }, 5000);
              this.save = false;
              this.showIndex = -1;
            }
            this.savemedicalBoolean = false;
          },
          (err) => {
            this.appservice.sessionOut(err);
            this.savemedicalBoolean = false;
          }
        );
    } else {
      this.alert = this.selectedlang.inf;
      this.validationMessage = this.selectedlang.nochanges;
      this.savemedicalBoolean = false;
      this.openModal(this.validateAddedQn);
    }
  }

  viewQns(i) {
    if (this.showIndex === i) {
      this.showIndex = -1;
    } else {
      this.showIndex = i;
    }

    if (this.TCProceduresList[i].medicalQnsList.length === 0) {
      this.getMedicalQuestions(i);
    }
  }

  getMedicalQuestions(i) {
    const data = {
      testCenterId: localStorage.getItem("testCenterId"),
      cptCode: this.TCProceduresList[i].cptCode,
      defaults: "true",
    };
    this.appservice.getmedicalquestions(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          this.TCProceduresList[i].medicalQnsList = res["entity"];
          if (
            this.TCProceduresList[i].medicalQnsList &&
            this.TCProceduresList[i].medicalQnsList.length > 0
          ) {
            this.recalcMedIndex(i);
          }
        }
        if (res && res["status"] && res["status"]["status"] === 204) {
          this.Message = "";
          this.errorMessage = this.selectedlang.noRecMed;
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  submitMedQns(i) {
    this.TCProceduresList[i].questionAdded = true;

    if (!this.TCProceduresList[i].question) {
      this.alert = this.selectedlang.inf;
      this.validationMessage = this.selectedlang.empty;
      this.openModal(this.validateAddedQn);
    }

    if (
      this.TCProceduresList[i].question &&
      this.TCProceduresList[i].question != null
    ) {
      this.save = true;
      const data = {
        medicalQuestion: {
          id: "",
          gender: this.selectedType,
          question: this.TCProceduresList[i].question,
          active: true,
          deleted: false,
          defaults: false,
          answer1: this.TCProceduresList[i].answer1,
          answer2: this.TCProceduresList[i].answer2,
          procedureInfo: {
            id: this.TCProceduresList[i].procedureId,
          },
          yesOrNoText: this.TCProceduresList[i].yesOrNoText,
        },

        active: true,
        deleted: false,
        testCenterId: localStorage.getItem("testCenterId"),
      };

      this.TCProceduresList[i].medicalQnsList.push(data);
      if (
        this.TCProceduresList[i].medicalQnsList &&
        this.TCProceduresList[i].medicalQnsList.length > 0
      ) {
        this.recalcMedIndex(i);
      }
      this.TCProceduresList[i].question = "";
      this.TCProceduresList[i].questionAdded = false;
      this.addqnshow = false;

      this.TCProceduresList[i].cancel = false;
      this.TCProceduresList[i].cancelIndex = -1;
      this.changed("", "both");
      this.TCProceduresList[i].addqnshow = false;
    }
  }
  addQuestion(i) {
    if (this.TCProceduresList[i].cancel) {
      this.TCProceduresList[i].cancel = false;
    } else {
      this.TCProceduresList[i].cancel = true;
    }
    if (this.TCProceduresList[i].cancelIndex === i) {
      this.TCProceduresList[i].cancelIndex = -1;
    } else {
      this.TCProceduresList[i].cancelIndex = i;
    }
    this.TCProceduresList[i].yesOrNoText = "true";
    this.TCProceduresList[i].addqnshow = true;
    this.TCProceduresList[i].answer1 = "";
    this.TCProceduresList[i].answer2 = "";
  }

  changed(value, type) {
    if (type === "both") {
      this.selected1 = true;
      this.selected2 = false;
      this.selected3 = false;
    }
    if (type === "male") {
      this.selected1 = false;
      this.selected2 = true;
      this.selected3 = false;
    }
    if (type === "female") {
      this.selected1 = false;
      this.selected2 = false;
      this.selected3 = true;
    }
    this.selectedType = type;
    this.selected = true;
  }

  getProcedureDisplayName(row: any): string {
    if (!row) { return ''; }
    if (row.procedureName) { return row.procedureName.trim(); }
    return row.cptCode || '';
  }

  private normalizeProcedureRow(row: any): any {
    const cptCode = this.asTrimmedString(
      this.pickFirstValue(row, ["cptCode", "procedureCode"])
    );
    const procedureName = this.asTrimmedString(
      this.pickFirstValue(row, [
        "procedureName",
        "procedureDescription",
        "procedureDesc",
        "description",
      ]) || cptCode
    );
    const examName = this.asTrimmedString(
      this.pickFirstValue(row, ["examName", "examShortName"])
    );
    const bodyPartName = this.asTrimmedString(
      this.pickFirstValue(row, ["bodyPartName", "bodyPart"])
    );

    return Object.assign({}, row, {
      cptCode,
      procedureName,
      examName,
      bodyPartName,
    });
  }

  private pickFirstValue(row: any, keys: string[]): any {
    if (!row) {
      return null;
    }
    for (const key of keys) {
      const value = row[key];
      if (value !== undefined && value !== null && String(value).trim() !== "") {
        return value;
      }
    }
    return null;
  }

  private asTrimmedString(value: any): string {
    return value === undefined || value === null ? "" : String(value).trim();
  }
}
